import styled from '@emotion/styled'

import { Color, theme } from '../../../../constants'
import { Clickable, Icon, IconName, Text } from '../../../../elements'
import { Cell } from '../components/Cell'
import { Row } from '../components/Row'
import { composableZIndex } from '../consts'
import { useSchedule } from '../useSchedule'

const Body = styled(Clickable)({
  display: 'flex',
  color: Color.MEDIUM_BLUE,
  height: '100%',
  justifyContent: 'center',
  background: Color.WHITE,
  ':hover': {
    background: Color.LIGHTER_BLUE,
  },
  fontWeight: 700,
  zIndex: composableZIndex.newShiftRow,
  transition: 'background 0.2s ease-in-out',
  position: 'sticky',
  left: 0,
  gap: theme.spacing[2],
})

type ButtonProps = {
  label: string
  icon?: IconName
  onClick: () => void
  permanent?: boolean
}

export const Button = (props: ButtonProps) => {
  const { enableEditing, columnCount, containerWidth } = useSchedule()

  if (!props.permanent && !enableEditing) return null
  if (!containerWidth) return null

  return (
    <Row>
      <Cell style={{ padding: 0 }} colSpan={columnCount}>
        <Body
          styles={{ width: containerWidth }}
          onClick={() => props.onClick()}
          hoverBackgroundColor={Color.LIGHTEST_BLUE}
        >
          <Text py={2}>{props.label}</Text>
          {props.icon && <Icon size="sm" name={props.icon} />}
        </Body>
      </Cell>
    </Row>
  )
}
